<template>
    <div class="panorama-container">
        <panorama-table-swiper :refHeaderRow="refHeaderRow" :refTable="refTable">
            <table ref="table" :key="displayedSubjects.length">
                <tr class="subjects-row">
                    <th></th>
                    <th></th>
                    <subjects-titles
                        :subjects="displayedSubjects"
                        :minNumberOfDisplayedSubjects="minNumberOfDisplayedSubjects"
                    />
                </tr>
                <tr ref="headerRow" class="header-row">
                    <th>
                        <panorama-header-item
                            title="Conventions collectives"
                            toolTip="Conventions collectives applicables de type étendue ou syndiquée"
                        />
                    </th>
                    <th>
                        <panorama-header-item
                            title="NAF"
                            toolTip="Codes NAF 2025 définis dans la convention collective ou donnés à titre indicatif selon notre interprétation"
                        />
                    </th>
                    <subjects-headers :subjects="displayedSubjects" />
                </tr>
                <panorama-convention-row
                    v-for="convention in conventions"
                    :key="convention.variantId"
                    :convention="convention"
                    :displayedSubjects="displayedSubjects"
                    :insurers="insurers"
                    :annotationOptions="annotationOptions"
                    :apenafsByCode="apenafsByCode"
                />
            </table>
        </panorama-table-swiper>
    </div>
</template>

<script>
import SubjectsHeaders from "./result-display/SubjectsHeaders.vue";
import SubjectsTitles from "./result-display/SubjectsTitles.vue";
import PanoramaConventionRow from "./PanoramaConventionRow.vue";
import PanoramaHeaderItem from "./PanoramaHeaderItem.vue";
import PanoramaTableSwiper from "./PanoramaTableSwiper.vue";

export default {
    components: {
        SubjectsHeaders,
        SubjectsTitles,
        PanoramaConventionRow,
        PanoramaHeaderItem,
        PanoramaTableSwiper,
    },
    props: [
        "conventions",
        "displayedSubjects",
        "insurers",
        "annotationOptions",
        "apenafsByCode",
        "minNumberOfDisplayedSubjects",
        "panoramaQuery",
    ],
    data() {
        return {
            isMounted: false,
        };
    },
    mounted() {
        this.isMounted = true;
    },
    computed: {
        refHeaderRow() {
            if (!this.isMounted) return null;
            return this.$refs.headerRow;
        },
        refTable() {
            if (!this.isMounted) return null;
            return this.$refs.table;
        },
    },
};
</script>

<style scoped lang="sass">
$header-height: 55px
$subject-row-height: 60px

.panorama-container
    position: relative

table
    border-collapse: collapse
    transition: transform 0.1s ease-in-out

    ::v-deep tr
        &.header-row
            th
                background: $color-background
                position: sticky
                top: $header-height + $subject-row-height
                z-index: 2
        &.subjects-row
            th
                background: $color-white
                position: sticky
                top: $header-height
                z-index: 2
        th
            margin: 10px
            min-width: 250px
            height: 40px
            &:nth-child(1)
                width: 250px
</style>
